import { CheckCircle2, TrendingUp, Shield, Zap, Target, Award, Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";

const benefits = [
  {
    title: "Sin conocimientos técnicos",
    description: "No necesitas saber de diseño ni programación. Solo llena formularios."
  },
  {
    title: "Redactor con IA",
    description: "Genera descripciones, títulos y mensajes profesionales en segundos con Gemini 3. Disponible desde plan Pro.",
    badge: "PRO"
  },
  {
    title: "Leads en tu Dashboard + Email",
    description: "Recibe los datos de cada prospecto en tu panel y por correo. Exporta a CSV para cerrar más rápido."
  },
  {
    title: "Mide tus campañas",
    description: "Conecta Facebook Pixel, Google Ads y más para optimizar tu inversión."
  },
  {
    title: "Marca personal",
    description: "Personaliza colores y estilo para proyectar una imagen profesional."
  },
  {
    title: "Soporte en español",
    description: "Equipo de soporte listo para ayudarte a vender más propiedades."
  }
];

export const Benefits = () => {
  const icons = [CheckCircle2, Sparkles, TrendingUp, Target, Shield, Award];

  return (
    <section id="beneficios" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Images */}
          <div className="space-y-6">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80"
                alt="Asesor inmobiliario profesional"
                className="w-full h-80 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-purple/50 to-transparent"></div>
              <div className="absolute bottom-6 left-6 text-white">
                <p className="text-2xl font-bold">+500</p>
                <p className="text-sm opacity-90">Agentes activos</p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-brand-purple rounded-2xl p-6 text-white">
                <p className="text-3xl font-bold mb-1">3x</p>
                <p className="text-sm opacity-90">Más conversiones que portales tradicionales</p>
              </div>
              <div className="bg-gray-900 rounded-2xl p-6 text-white">
                <p className="text-3xl font-bold mb-1">5 min</p>
                <p className="text-sm opacity-90">Tiempo promedio para crear landing</p>
              </div>
            </div>
          </div>

          {/* Benefits Content */}
          <div>
            <span className="inline-block bg-purple-100 text-brand-purple px-4 py-1 rounded-full text-sm font-medium mb-4">
              Para Agentes
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Beneficios de usar{" "}
              <span className="text-brand-purple">nuestra plataforma</span>
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Herramientas diseñadas específicamente para vendedores inmobiliarios 
              que quieren destacar de la competencia
            </p>

            <div className="space-y-4">
              {benefits.map((benefit, idx) => {
                const Icon = icons[idx];
                return (
                  <div
                    key={idx}
                    className="flex items-start space-x-4 p-4 rounded-xl hover:bg-purple-50 transition-colors duration-300 group"
                  >
                    <div className="flex-shrink-0 mt-1">
                      <div className="p-2 bg-purple-100 rounded-lg group-hover:bg-brand-purple transition-colors duration-300">
                        <Icon className="w-6 h-6 text-brand-purple group-hover:text-white transition-colors duration-300" />
                      </div>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-1 flex items-center gap-2">
                        {benefit.title}
                        {benefit.badge && (
                          <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-gradient-to-r from-amber-400 to-amber-500 text-white">
                            {benefit.badge}
                          </span>
                        )}
                      </h3>
                      <p className="text-gray-600">{benefit.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="mt-10">
              <Link to="/register">
                <Button
                  size="lg"
                  className="bg-brand-purple hover:bg-brand-pink text-white px-8 py-6 text-lg"
                >
                  Comenzar Ahora
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
